<template>
  <fragment>
    <!-- <c-docs-hero class="illustration-section-01" /> -->
    <c-generic-section class="illustration-section-01">
      <c-section-header :data="section" class="center-content" />
      <div class="container-xs">
        <c-accordion class="reveal-from-bottom" active data-reveal-delay="600">
          <c-accordion-item title="Step 1: Invite SRVControl to your Discord server" active>
            <a href="/invite" target="_blank"> Click here</a>
            to invite SRVControl to your Discord server.
          </c-accordion-item>
          <c-accordion-item title="Step 2: Configuration">
            Configuring SRVControl is simple via our <a href="https://app.srvcontrol.net" target="_blank">dashboard</a>.<br />
            If you use dashflo.net as your host, you're already good to go with the default settings preset and can skip to Step 3!<br /><br />
            If your host has a settings preset on our <a href="https://app.srvcontrol.net" target="_blank">dashboard</a>, select it and continue to
            Step 3!<br /><br />
            If you're reading this far, your host most likely doesn't have a settings preset on our
            <a href="https://app.srvcontrol.net" target="_blank">dashboard</a> or you run your own panel. Don't worry as SRVControl works with any
            Pterodactyl instance!<br /><br />
            Select the "Custom" preset to unlock the text fields for editing. You'll now need to enter the domain where you access your panel in the
            "Panel Domain" box. <br />This should just be the domain and nothing else, an example of a valid Panel Domain would be
            <code>panel.host.com</code>.
          </c-accordion-item>
          <c-accordion-item title="Step 3: Extra Configuration (optional)">
            There's some extra options for you to configure on the <a href="https://app.srvcontrol.net" target="_blank">dashboard</a>, such as the
            language which messages are shown in.
          </c-accordion-item>
          <c-accordion-item title="Step 4: Generate an API key on your panel">
            For SRVControl to work, you need to generate an <strong>account</strong> API key on your panel. If you run your own panel, it's important
            to note that SRVControl doesn't work with application keys, only account ones.<br /><br />
            The place where you would get a valid API key is <code>panel.host.com/account/api</code>.<br />
            To create a new key, set the description to <code>SRVControl</code>, leave the allowed IPs box empty, and press create.<br /><br />
            It's very important to save your new API key somewhere safe, as it will only ever be shown to you <strong>once</strong>.
          </c-accordion-item>
          <c-accordion-item title="Step 5: Register your API key with SRVControl">
            In your Discord server, run the slash command <code>/register</code> with the API key you generated in Step 4 as the
            <code>key:</code> argument.<br /><br />

            If the SRVControl bot responds with a success message, great! You have completed setting up SRVControl!<br /><br />

            If the SRVControl bot responds with an error message, oops! You may have misconfigured something in Step 2, generated the wrong type of
            API key, the panel you're trying to use SRVControl with isn't accessible at the moment, or it may simply be an error that's on us.<br />
            Take a look at the message given to you, as it will tell you exactly why your registration failed.<br /><br />

            If you still need help setting up, <a href="/discord">we're here to help in our Discord server!</a>
          </c-accordion-item>
        </c-accordion>
      </div>
    </c-generic-section>
  </fragment>
</template>

<script>
import CLayout from '@/layouts/LayoutDefault.vue';
import CGenericSection from '@/components/sections/GenericSection.vue';
import CSectionHeader from '@/components/sections/partials/SectionHeader.vue';
import CAccordion from '@/components/elements/Accordion.vue';
import CAccordionItem from '@/components/elements/AccordionItem.vue';

export default {
  name: 'Documentation',
  components: {
    CGenericSection,
    CAccordion,
    CAccordionItem,
    CSectionHeader
  },
  created() {
    this.$emit('update:layout', CLayout);
  },
  data() {
    return {
      section: {
        title: 'Getting Started',
        paragraph: 'Getting started with SRVControl is easy, follow the instructions below.'
      }
    };
  }
};
</script>
